/**
 * 找样任务详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react'
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Info from "../components/Info";
import "./index.less";
import {Empty,Spin,Modal,message,Button} from 'antd';
import Contact from "./components/Contact";
import Lang from "@components/Lang/Lang"
import qs from 'query-string';
import dayjs from 'dayjs';
import PageCommon from  "@components/PageCommon/PageCommon";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import request from "../../../../utils/request";
import RecommendList from "./components/RecommendList";
import BuyerInfo from "../components/BuyerInfo";
import {toFixed2} from '@utils/utils';
class Page extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //认领loading
            bindLoading:false,
            loading:true,
            extra:{},
            model: {},
            list:[],
            pagingQuery:{
                pageSize:9999, //需求临时说不需要分页，所以后端说这里取一个很大的值
                pageIndex:1,
                total:0
            },
        }
        this.id = (qs.parse(props.location.search) || {}).id;
    }

    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;

    doBind(){
        if(this.state.bindLoading){
            return false;
        }
        this.setState({
            bindLoading:true
        },()=>{
            let state = {
                bindLoading:false
            }
            request.post(
                "/service/mg/fuzzy/do-bind",
                {
                    id:this.id
                }
            ).then((response) => {
                const res = response.data;
                if(res.success&&res.valid){
                    message.success(__getServerLanguage(Lang({id:'GenJinChengGong',default:'跟进成功'})))
                    this.getData(()=>{
                        this.getGoodsData(1);
                    });
                }else{
                    this.setState(state);
                }
            },()=>{
                this.setState(state);
            });
        })
    }

    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    onChangePage(page, pageSize){
        this.getData(page, pageSize)
    }

    /**
     * 找样详情
     **/
    getData(callback){
        request.post(
            "/service/mg/fuzzy/details",
            {
                id:this.id
            }
        ).then((response) => {
            const res = response.data;
            if(res.success&&res.valid){
                let {model={},extra= {}} = res;
                this.setState({
                    extra:extra,
                    model:model,
                    //跟进的按钮这时候才恢复可以点击
                    bindLoading:false
                },()=>{
                    if(typeof callback=='function'){
                        callback();
                    }
                })
            }
        });
    }

    /**
     * 获取商品数据
     **/
    getGoodsData(pageIndex){
        this.setState({
            loading:true,
        },()=>{
            var state = {
                loading:false
            };
            $.ajax({
                url: "/service/mg/fuzzy/details-goods-list",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify({
                    fuzzySampId:this.id,
                    pagingQuery:{
                        pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                        pageSize: this.state.pagingQuery.pageSize
                    }
                }),
                success:(res)=>{
                    if(res.success&&res.valid){
                        state.list = res.models||[];
                    }
                    if(res.paging){
                        state.pagingQuery = {
                            pageIndex:res.paging&&res.paging.pageNum,
                            pageSize:res.paging&&res.paging.pageSize,
                            total:res.paging&&res.paging.total
                        }
                    }else{
                        state.pagingQuery = {
                            pageIndex:1,
                            pageSize:9999,
                            total:0
                        }
                    }
                    this.setState(state,()=>{
                        this.onRefPageCommonChild.isShowTop();
                    });
                },
                error:()=>{
                    this.setState(state);
                }
            });
        })
    }

    /**
     * 切换分页
     * @param page 当前页面
     * @param pageSize 分页大小
     */
    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getGoodsData();
        })
    }

    tipBind(){
        let modal = Modal.info({
            title:__getServerLanguage('TiShi'),
            wrapClassName:"bind-tip__modal",
            content:<div className="color089 font_14">{Lang({id:'XuYaoGenJinRenWuHouCaiNen',default:'需要跟进任务后才能操作。'})}</div>,
            icon:<i></i>,
            footer:<div className="text-right mt_16">
                <Button type="primary" onClick={()=>{
                    modal.destroy();
                }}>{Lang({id:'QueDing',default:'确定'})}</Button>
            </div>
        })
    }

    /**
     * 获取状态
     * @param item
     * @return {null|*}
     */
    getStatusHtml(item){
        if(item.status=='15'){
            return <div className="status-label status-label15">
                {__getServerLanguage('ZhaoYangZhong')}
            </div>
        }else if(item.status=='20'){
            return <div className="status-label status-label20">
                {__getServerLanguage('YouZhaoDao')}
            </div>
        }else if(item.status=='50'){
            return <div className="status-label status-label50">
                {__getServerLanguage('RenWuWanCheng')}
            </div>
        }else if(item.status=='40'){
            return <div className="status-label status-label40">
                {__getServerLanguage('YiQuXiao')}
            </div>
        }
        return null;
    }

    getPercentage(model){
        let all = model.effectiveEndTime - model.effectiveStartTime;
        let consume = model.currentTime - model.effectiveStartTime;
        return ((consume/all)*100).toFixed(2)+'%';
    }

    getEmptyText(model){
        let text = __getServerLanguage('YiFenXiXuQiuPinLeiJingLiZ');
        switch (model.status) {
            case '40':
                text = __getServerLanguage('ZanWuShangPin');
                break;
            case '50':
                text = __getServerLanguage('BaoQianWoMenMeiYouZhaoDao');
        }
        return text;
    }

    componentDidMount() {
        this.getData(()=>{
            this.getGoodsData();
        });
    }

    render(){
        const state = this.state;
        const {list,model,pagingQuery,extra} = this.state;
        const {buyerVO={}} = model;
        const crumb = [
            {name: Lang({id:'ZhaoYangGuanLi',default:"找样管理"}),link:'/customer/fuzzy-task-list?tabType=13'},
            {name: Lang({id:'ZhaoYangXiangQing',default:"找样管理"})},
        ];
        let btnList = [];
        if(model.status=='50'||model.status=='40'){
            btnList = [{
                btn: Lang({id:"FanHui",default:"返回"}),
                icon:"ri-arrow-go-back-fill font_16 mr_4 color-blue",
                btnClick:()=>{
                    window.history.back();
                }
            }]
        }else{
            btnList = [{
                btn: Lang({id:"FanHui",default:"返回"}),
                icon:"ri-arrow-go-back-fill font_16 mr_4 color-blue",
                btnClick:()=>{
                    window.history.back();
                }
            },
                {
                    btn: Lang({id:"WoYaoGenJin",default:"我要跟进"}),
                    auth:'Wait_Follow_Fuzzy_Task',
                    icon:"ri-check-line mr_4 font_16 color-green",
                    btnClick:()=>{
                        this.doBind();
                    }
                }
            ];
        }
        return (
            <PageCommon onRef={this.onRefPageCommon}
                        showTop={true}
                        btnList={(model.recommendUserIds||[]).indexOf(extra.userId)!=-1?[]:btnList}>
                <CommonBreadcrumb list={crumb}></CommonBreadcrumb>
                <div className="wp-box">
                    <Info model={model}
                          fuzzyId={this.id}></Info>
                    <BuyerInfo model={model}></BuyerInfo>
                    {
                        Object.keys(model).length>0?
                            <Spin spinning={this.state.loading}>
                                <div className="fuzzy-detail__wrap">
                                    <div className="flex-box ant-row-flex-space-between mb_12">
                                        <div className="flex-box">
                                            {/*推荐商品*/}
                                            {
                                                model.status!='50'&&model.status!='40'?
                                                    (
                                                        (model.recommendUserIds||[]).indexOf(extra.userId)==-1?
                                                            <a className="btn-recommend mr_12"
                                                               onClick={this.tipBind.bind(this)}
                                                               aria-disabled={true}>
                                                                {__getServerLanguage('ZuiXinShangPin')}
                                                            </a>:
                                                            <Link
                                                                className="btn-recommend mr_12"
                                                                target = "_self"
                                                                to={`/customer/fuzzy-recommend?id=${this.id}`} >
                                                                {__getServerLanguage('ZuiXinShangPin')}
                                                            </Link>
                                                    )
                                                :
                                                null
                                            }

                                            <Contact fuzzyId={this.id}
                                                     title={__getServerLanguage('LianXiKeHu')}
                                                     model={model}
                                                     callback={this.getData.bind(this)}
                                                     // showEdit={(model.recommendUserIds||[]).indexOf(extra.userId)!=-1&&model.status!='50'&&model.status!='40'}
                                                     // 开放给海外客服可以去补充找样的条件，不限制发起跟客户的对话
                                                     showEdit={true}
                                            >
                                                <a className="btn-contact mr_12">
                                                    <i className="ri-message-2-line font_18 mr_4"></i>
                                                    <span>{__getServerLanguage('LianXiKeHu')}</span>
                                                    {
                                                        model.messageCount?
                                                            <span className={`num ${model.isNewMessage?'num-red':'num-green'}`}>
                                                                {model.messageCount}
                                                            </span>
                                                            :
                                                            null
                                                    }

                                                </a>
                                            </Contact>
                                            {
                                                (model.status!='40'&&model.status!='50')?
                                                    <span className="btn-rate">
                                                        <div className="bg-per mr_4" style={{width:this.getPercentage(model)}}></div>
                                                        <div className="btn-rate__content">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                <path d="M4.5 3H3V1.5H15V3H13.5V4.5C13.5 5.71157 12.8878 6.68601 12.1171 7.4825C11.5899 8.02725 10.9485 8.529 10.2982 9C10.9485 9.471 11.5899 9.97275 12.1171 10.5175C12.8878 11.314 13.5 12.2885 13.5 13.5V15H15V16.5H3V15H4.5V13.5C4.5 12.2885 5.11212 11.314 5.88293 10.5175C6.41012 9.97275 7.05152 9.471 7.70183 9C7.05152 8.529 6.41012 8.02725 5.88293 7.4825C5.11212 6.68601 4.5 5.71157 4.5 4.5V3ZM6 3V4.5C6 5.01385 6.19519 5.50124 6.57848 6H11.4215C11.8048 5.50124 12 5.01385 12 4.5V3H6ZM9 9.91642C8.2161 10.4701 7.506 10.9972 6.96083 11.5606C6.81756 11.7087 6.69005 11.8548 6.57848 12H11.4215C11.3099 11.8548 11.1824 11.7087 11.0392 11.5606C10.494 10.9972 9.7839 10.4701 9 9.91642Z" fill="#E24E1D"/>
                                                            </svg>
                                                            <span className="mr_4">
                                                                {__getServerLanguage('QianWanChengHuiFu',model.effectiveEndTime?dayjs(model.effectiveEndTime).format('YYYY.MM.DD'):'-')}
                                                            </span>
                                                        </div>
                                                    </span>
                                                    :
                                                    null
                                            }
                                        </div>
                                        {this.getStatusHtml(model)}
                                    </div>
                                    {
                                        list.length==0?
                                            <Empty className="mt_16 mb_16" description={
                                                this.getEmptyText(model)
                                            }></Empty>
                                            :
                                            null
                                    }
                                    {
                                        pagingQuery.total>0?
                                            <div className="fuzzy-detail__main">
                                                {/*为你找到的样品，共{pagingQuery.total}款*/}
                                                <p className="color066 font_14 lineH_150p mb_8">
                                                    <i className="ri-error-warning-fill font_14 mr_10 font-main2"></i>
                                                    <span className="color089">
                                                        {/*你累计推荐 {model.meSkuNum||0} 款商品，{model.addCartSkuNum||0} 款被选中，选品率 {(model.addCartSkuRatio||0)*100}%*/}
                                                        {__getServerLanguage('NiLeiJiTuiJianKuanShangPi',model.meSkuNum||0,model.addCartSkuNum||0,((model.addCartSkuRatio||0)*100).toFixed(2))}
                                                    </span>
                                                </p>
                                                <RecommendList currencySymbol={buyerVO.currencySymbol} list={list}></RecommendList>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </Spin>
                            :
                            null
                    }

                </div>
            </PageCommon>
        )
    }
}

Page.defaultProps = {
}

Page.propTypes = {

}
export default Page;
